// 根据环境变量设置不同的域名配置
const getDomainConfig = () => {
  const env = process.env.REACT_APP_ENV;
  
  switch (env) {
    case 'dev':
    case 'test':
      return {
        ope: 'https://ope.test.kdslife.com',
        sso: 'https://sso.test.kdslife.com',
        service: 'https://service.test.kdslife.com'
      };
    case 'pre':
      return {
        ope: 'https://ope.pre.kdslife.com',
        sso: 'https://sso.pre.kdslife.com',
        service: 'https://service.pre.kdslife.com'
      };
    case 'prod':
      return {
        ope: 'https://ope.xhs.com',
        sso: 'https://sso.kdslife.com',
        service: 'https://service.kdslife.com'
      };
    default:
      return {
        ope: 'https://ope.test.kdslife.com',
        sso: 'https://sso.test.kdslife.com',
        service: 'https://service.test.kdslife.com'
      };
  }
};

export const domainConfig = getDomainConfig();